import BaseService from '@/api/services/index'
import Reference from '@/api/models/Reference'
import References from '@/api/models/References'
import CampaignReferences from '@/api/models/CampaignReferences'
import Brand from '@/api/models/Brand'

export default class ReferenceService extends BaseService {
    public getBrand (): Promise<Brand> {
        return this.api.get<never, Brand>(
            this.getUrl('get_brand')
        )
    }

    public getSites (): Promise<Array<Reference>> {
        return this.api.get<never, Array<Reference>>(
            this.getUrl('get_sites')
        )
    }

    public getReferences (): Promise<References> {
        return this.api.get<never, References>(
            this.getUrl('get_settings_data')
        )
    }

    public getCampaignReferences (campaignId: number): Promise<CampaignReferences> {
        return this.api.get<never, CampaignReferences>(
            this.getUrl('get_campaign_settings_data', { id: campaignId })
        )
    }
}
